import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLightning: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconLightning"><Path d="M8.38281 2L2.38281 14H7.76386L5.88334 22.7757L23.631 7H16.767L19.767 2H8.38281Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLightning;
